import React, { useState } from "react";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import { Tooltip } from "@mui/material";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import CallDetailsForm from "./CallDetailsForm";

const LeadDetailsSidebar = ({ enrollment }) => {
  return (
    <div className="col-12 theiaStickySidebar">
      <CallDetailsForm data={enrollment} />
    </div>
  );
};

export default LeadDetailsSidebar;
